function defaultCellRenderer({ cellData }) {
  if (cellData == null) {
    return '';
  } else {
    return String(cellData);
  }
}

export default defaultCellRenderer;
